<template>
  <div>
    <label v-for="menuModel in menus">
      <el-menu-item v-if="menuModel.children == null" :index="menuModel.path">
        {{menuModel.name}}
      </el-menu-item>

      <el-submenu v-if="menuModel.children != null" :index="menuModel.id">
        <template slot="title">
          <span slot="title">{{menuModel.name}}</span>
        </template>
      <left_menu :menus="menuModel.children"></left_menu>
    </el-submenu>
    </label>
  </div>
</template>

<script>
  import left_menu from "./menu";
  export default {
    name: "left_menu",
    data(){
      return {

      }
    },
    methods:{
      getTitle:function(mMdel){
        if(mMdel.iconClass != null){
          let html="<div class=\"jicon "+mMdel.iconClass+"\"></div>"
          html+="<div class=\"m_text\">"+mMdel.name+"</div>"
          return html;
        }else{
          return mMdel.name;
        }
      }
    },
    mounted:function(){
      this.$router.push(this.menus[0].path);
    },
    components: {
      left_menu
    },
    props:["menus"]
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/menu.vue